import {useEffect} from 'react'
import apiClient, { getCsrfCookie } from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setAuthStatus, setToken } from './authSlice';
import { setUser } from '../../components/Auth/userSlice';
import { useSelector } from 'react-redux';


export const CheckAuth = () => {
    const isAuth = useSelector((state) => state.auth.isAuthenticated);
    const token = useSelector((state) => state.auth.authToken); 

    const dispatch = useDispatch();
    
    // Check for remember me authentication on app load
    useEffect(() => {
        const checkRememberMe = () => {
            const rememberMe = localStorage.getItem('remember-me');
            const authToken = localStorage.getItem('auth-token');
            const authExpiration = localStorage.getItem('auth-expiration');
            const userData = localStorage.getItem('user-data');
            
            if (rememberMe === 'true' && authToken && authExpiration && userData) {
                const currentTime = new Date().getTime();
                const expirationTime = parseInt(authExpiration);
                
                // Check if token hasn't expired
                if (currentTime < expirationTime) {
                    try {
                        const user = JSON.parse(userData);
                        dispatch(setAuthStatus('authenticated'));
                        dispatch(setToken(authToken));
                        dispatch(setUser(user));
                        return;
                    } catch (error) {
                        console.error('Error parsing stored user data:', error);
                    }
                }
            }
            
            // If no valid remember me session, check for regular auth
            if (authToken && authExpiration) {
                const currentTime = new Date().getTime();
                const expirationTime = parseInt(authExpiration);
                
                // If token expired, clear all auth data
                if (currentTime >= expirationTime) {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('auth-expiration');
                    localStorage.removeItem('remember-me');
                    localStorage.removeItem('user-data');
                    localStorage.setItem('authstatus', false);
                }
            }
        };
        
        checkRememberMe();
    }, [dispatch]);
    
    const { isLoading: ischeckingAuth, refetch: checkAuth } = useQuery(
        "check-auth",
        async () => {
            if (!isAuth) {
                // Get CSRF cookie first
                await getCsrfCookie();
                return await apiClient.get("/api/check-auth");  
            }
          
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setAuthStatus(res.data.message))
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        checkAuth();
      }, []);
 
}

export default CheckAuth
